import { Card } from "../../../components/Card";
import { Skeleton } from "../../../components/Skeleton";
import { BackButton } from "../../../components/Button/BackButton";

const FILTER_BUTTON_WIDTHS = ["w-12", "w-28", "w-16", "w-24"];
const SECTION_COUNT = 3;
const BADGES_PER_SECTION = 4;

function BadgeItemSkeleton() {
    return (
        <div className="py-2 px-4 flex flex-col gap-1 items-center max-w-[150px]">
            <Skeleton className="w-20 h-20 rounded-full" />
            <Skeleton className="w-[108px] h-3" />
        </div>
    );
}

export function AchievementSectionSkeleton() {
    return (
        <div className="flex flex-col gap-2">
            <div className="flex items-center justify-between">
                <div className="flex flex-col gap-1">
                    <Skeleton className="w-40 h-4" />
                    <Skeleton className="w-36 h-4" />
                </div>
                <div className="flex items-center gap-2">
                    <Skeleton className="w-20 h-4" />
                    <Skeleton className="w-6 h-6 rounded-full" />
                </div>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 2xl:grid-cols-6 items-center gap-2">
                {Array.from({ length: BADGES_PER_SECTION }).map((_, index) => (
                    <BadgeItemSkeleton key={index} />
                ))}
            </div>
        </div>
    );
}

export function AchievementFullViewSkeleton({ onCloseAchievementFullView }: { onCloseAchievementFullView: () => void }) {
    return (
        <Card className="!p-6">
            <div className="flex justify-center relative">
                <div className="absolute -top-1 left-0">
                    <BackButton text="Back" onClick={onCloseAchievementFullView} />
                </div>
                <div className="flex flex-col gap-1 items-center">
                    <span className="text-black text-2xl font-bold">Achievements</span>
                    <span>Build your skills and earn badges</span>
                </div>
            </div>
            <div className="flex items-center gap-2">
                {FILTER_BUTTON_WIDTHS.map((width, index) => (
                    <Skeleton key={index} className={`${width} h-[34px] rounded-[5px]`} />
                ))}
            </div>
            <AchievementSectionsSkeleton />
        </Card>
    );
}

export function AchievementSectionsSkeleton() {
    return (
        <div className="flex flex-col gap-4 mt-6">
            {Array.from({ length: SECTION_COUNT }).map((_, index) => (
                <AchievementSectionSkeleton key={index} />
            ))}
        </div>
    );
}
